module.exports = __webpack_public_path__ + "img/cream-cheese-frosting.164d3062.jpg";